// src/regexInApp.ts
var inAppRegExps = [
  "WebView",
  "(iPhone|iPod|iPad)(?!.*Safari/)",
  // Apple devices but not with "Safari/" following
  "Android.*wv\\)",
  "FB_\\w|FB\\w",
  // Match Facebook FB_ or FB then word char
  "Snapchat"
];
var inappRegex = new RegExp(
  `${inAppRegExps.map((reg) => `(${reg})`).join("|")}`,
  "ig"
);

// src/utils.ts
var WIN_ERROR = "Window is not available and no user agent was provided.";
var getUA = () => {
  var _a, _b;
  if (typeof window !== "undefined") {
    const ua = ((_a = window == null ? void 0 : window.navigator) == null ? void 0 : _a.userAgent) || ((_b = window == null ? void 0 : window.navigator) == null ? void 0 : _b.vendor) || // @ts-ignore
    (window == null ? void 0 : window.opera);
    if (ua)
      return ua;
  }
  console.error(WIN_ERROR);
  return "";
};

// src/regexAppName.ts
var appNameRegExps = {
  messenger: {
    regex: /\bFB[\w_]+\/(Messenger|MESSENGER)/,
    name: "Facebook Messenger"
  },
  facebook: {
    regex: /\bFB[\w_]+\//,
    name: "Facebook"
  },
  twitter: {
    regex: /\bTwitter/i,
    name: "Twitter"
  },
  line: {
    regex: /\bLine\//i,
    name: "Line"
  },
  wechat: {
    regex: /\bMicroMessenger\//i,
    name: "WeChat"
  },
  instagram: {
    regex: /\bInstagram/i,
    name: "Instagram"
  },
  tiktok: {
    regex: /musical_ly|Bytedance/i,
    name: "TikTok"
  },
  snapchat: {
    regex: /Snapchat/i,
    name: "Snapchat"
  }
};
var appKeys = Object.keys(
  appNameRegExps
);
var getAppKey = (ua) => {
  return appKeys.find((appName) => appNameRegExps[appName].regex.test(ua));
};

// src/index.ts
var InAppSpy = (options = {}) => {
  const { ua } = options;
  let userAgent = ua || getUA();
  if (!userAgent) {
    return {
      isInApp: false,
      appKey: void 0,
      appName: void 0,
      ua: userAgent
    };
  }
  const isInApp = userAgent.match(inappRegex) !== null;
  const appKey = isInApp ? getAppKey(userAgent) : void 0;
  return {
    isInApp,
    appKey,
    appName: appKey ? appNameRegExps[appKey].name : void 0,
    ua: userAgent
  };
};
var src_default = InAppSpy;
export {
  src_default as default
};
//# sourceMappingURL=index.mjs.map